const en = {
  common: {
    langToggle: "AR",
  },
  navbar: {
    items: ["Home", "Services", "Packages", "About Us", "Contact Us"],
  },
  home: {
    heroSlides: [
      {
        title: "We help you grow your business",
        description: "We provide a complete set of marketing services.",
      },
      {
        title: "Grow customers smartly",
        description: "Digital strategies tailored for each restaurant.",
      },
      {
        title: "Innovative, effective campaigns",
        description: "We turn your ideas into engaging digital campaigns.",
      },
    ],
    servicesCarousel: {
      title: "Our Services",
      more: "More services",
    },
    valuesPreview: {
      title: "Who we are and what we aim for",
      subtitle: "What we believe in and aspire to achieve",
      cards: [
        {
          icon: "eye",
          title: "Our Vision",
          desc: "To become the first partner for restaurant and café owners in digital success, turning ideas into innovative marketing campaigns with measurable results.",
        },
        {
          icon: "mail",
          title: "Our Mission",
          desc: "Providing integrated, tailored marketing solutions—from digital marketing to ad campaign management—to increase customers and strengthen the brand.",
        },
        {
          icon: "target",
          title: "Our Goals",
          desc: "To help every restaurant and café shine digitally and reach more customers easily and smartly.",
        },
      ],
    },
    faq: {
      title: "FAQ",
      items: [
        {
          q: "What services does Khubzah provide?",
          a: "We offer social media management, marketing consulting, influencer promotion, and integrated marketing solutions to help you grow your business.",
        },
        {
          q: "How can I request a package or service?",
          a: "Choose the service or package by clicking the button, and you’ll be redirected to the request form to complete the details and book your service.",
        },
        {
          q: "Do you offer free consultations?",
          a: "Yes. We provide a free initial consultation to understand your needs before recommending the right package.",
        },
      ],
    },
  },
  services: {
    cards: [
      {
        title: "Social Media Management",
        desc: "We manage your social media accounts to increase engagement and grow your audience.",
        details: [
          "Daily post scheduling",
          "Performance analysis of posts",
          "Engaging with audience and responses",
          "Monthly results report",
        ],
      },
      {
        title: "Marketing Consulting",
        desc: "We provide customized marketing consulting to help you create effective strategies to achieve your marketing goals.",
        details: [
          "Market and competitor analysis",
          "Detailed marketing strategy",
          "Tips to improve ad campaigns",
        ],
      },
      {
        title: "Influencer Promotion",
        desc: "We promote your products or services through the right influencers to achieve better results.",
        details: [
          "Identifying the right influencers for your target audience",
          "Managing campaigns with influencers",
          "Analyzing promotion results and reporting",
        ],
      },
      {
        title: "Advertising Campaigns",
        desc: "We create and run effective ad campaigns on TikTok and Instagram to raise brand awareness and achieve measurable results.",
        details: [
          "Designing attractive advertisements",
          "Targeting the right audience",
          "Monitoring performance and optimizing results",
          "Providing detailed performance reports",
        ],
      },
      {
        title: "Marketing Plan Preparation",
        desc: "We provide a comprehensive marketing plan to help you identify your target audience and create effective strategies.",
        details: [
          "Defining marketing objectives",
          "Creating content plans and scheduling campaigns",
          "Estimating budget and required resources",
        ],
      },
      {
        title: "Logo & Brand Identity Design",
        desc: "We offer logo and brand identity design services to help you build a strong and professional brand identity.",
        details: [
          "Creative and attractive logo design",
          "Choosing consistent colors and fonts",
          "Applying brand identity across all marketing materials",
        ],
      },
    ],
    orderButton: "Order Service",
  },
  packages: {
    heroTitle: "Packages",
    heroText:
      "Choose the package that fits your current stage, and let's build your digital presence professionally.",
    sectionTitle: "Choose the right package",
    mostPopular: "Most Popular",
    sectionSubtitle: "Flexible packages — tailored to your business needs.",
    cards: [
      {
        name: "Launch Package",
        desc: "A complete solution to start an organized digital presence that reflects your brand professionally.",
        sections: [
          {
            summary: "Package includes",
            items: [
              "Manage one platform (client choice)",
              "Basic visual identity design",
              "Initial marketing plan setup",
              "Marketing consultation",
            ],
          },
          {
            summary: "Expected outcome",
            items: [
              "Organized digital presence",
              "Clear identity that builds trust",
              "Strong start based on a solid plan",
            ],
          },
        ],
        cta: "Order Package",
      },
      {
        name: "Growth Package",
        desc: "Perfect for brands aiming for noticeable growth in engagement and sales.",
        sections: [
          {
            summary: "Package includes",
            items: [
              "Manage two platforms (client choice)",
              "Advanced marketing plan",
              "Paid ad campaigns",
              "Plan to boost engagement & orders",
              "Monthly development consultation",
            ],
          },
          {
            summary: "Expected outcome",
            items: [
              "Significant engagement growth",
              "More inquiries and orders",
              "Better conversion from followers to customers",
            ],
          },
        ],
        cta: "Order Package",
      },
      {
        name: "Scale Package",
        desc: "An advanced package with full management, professional strategy, and complete competitive analysis.",
        sections: [
          {
            summary: "Package includes",
            items: [
              "Multi-platform management",
              "Advanced ad campaigns",
              "Influencer promotion",
              "Comprehensive marketing plan",
              "Ongoing consultations",
            ],
          },
          {
            summary: "Expected outcome",
            items: [
              "Stronger positioning in the market",
              "Optimized campaigns that reduce cost per order",
              "Continuous improvement based on data & performance",
            ],
          },
        ],
        cta: "Order Package",
      },
    ],
    noteTitle: "How do we choose the best package for you?",
    noteText:
      "We start with a short session to understand your needs and goals, then we prepare a tailored offer based on the scope and required services.",
    bottomCtaTitle: "Not sure which package fits you?",
    bottomCtaText: "Let's help you build a plan that fits your business.",
    bottomCtaBtn: "Contact us now",
  },
  about: {
    heroTitle: "About Us",
    heroText:
      "We are a passionate team of marketers and creatives helping restaurants and cafés grow and stand out through smart, innovative strategies.",
    missionTitle: "Our Mission",
    missionLines: [
      "We specialize in helping restaurants and cafés grow in the digital market.",
      "We believe smart, innovative marketing is the key to success.",
      "We deliver integrated solutions to reach your audience and boost engagement.",
    ],
    valuesTitle: "Our Values",
    values: [
      { title: "Innovation", desc: "We deliver creative solutions.", icon: "zap" },
      { title: "Passion", desc: "Passion drives our excellence.", icon: "heart" },
      { title: "Collaboration", desc: "Teamwork achieves the best results.", icon: "users" },
      { title: "Excellence", desc: "We commit to top quality.", icon: "award" },
    ],
  },
  contact: {
    heroTitle: "Contact Us",
    heroText: "Send your project details and we’ll reach out soon.",
    formTitle: "Send a message",
    formSubtitle: "Fill in the details and we’ll contact you soon.",
    infoTitle: "Contact details",
    infoSubtitle: "You can reach us directly via:",
    followTitle: "Follow us",
    placeholders: {
      name: "Enter your name",
      phone: "05xxxxxxxxxx",
      email: "example@gmail.com",
      message: "Write your message",
    },
    button: {
      send: "Send",
      sending: "Sending...",
    },
    success: "✓ Message sent successfully. We'll contact you soon.",
    errors: {
      nameRequired: "Please enter your name.",
      phoneRequired: "Please enter your phone number.",
      phoneInvalid: "Phone number must be 10 digits.",
      emailRequired: "Please enter your email.",
      emailInvalid: "Invalid email format.",
      messageRequired: "Please write your message.",
    },
  },
  footer: {
    contactTitle: "Contact Us",
    address: "Riyadh, Saudi Arabia",
    email: "info@nkubzah.sa",
    socialTitle: "Follow us on social media",
    linksTitle: "Quick Links",
    links: ["Home", "Services", "Packages", "About Us", "Contact Us"],
    copyright: "&copy; 2026 Khubzah Solutions. All rights reserved.",
  }, 
  request: { /* new for request form */
  title: "Request a Service or Package",
  desc:
    "Please fill out the form below to request the service you want, and we will contact you as soon as possible.",
  labels: {
    name: "Full Name:",
    email: "Email:",
    phone: "Phone Number:",
    projectType: "Project Type:",
    company: "Project Name:",
    requestType: "Choose Request Type:",
    notes: "Additional Notes:",
    services: "Choose Required Services:",
    package: "Choose Package:",
  },
  placeholders: {
    name: "Enter your full name",
    email: "name@example.com",
    phone: "05xxxxxxxx",
    company: "Project name",
    notes: "Write your notes...",
  },
  projectTypes: {
    default: "Choose project type",
    restaurant: "Restaurant",
    coffeeShop: "Coffee Shop",
  },
  requestTypes: {
    services: "Services",
    packages: "Packages",
  },
  services: [
    "Social Media Management",
    "Marketing Consultation",
    "Influencer Promotion",
    "Marketing Plan",
    "Advertising Campaigns",
    "Logo & Brand Identity Design",
  ],
  packages: [
    "Launch Package",
    "Growth Package",
    "Expansion Package",
  ],
  button: {
    send: "Send Request",
  },
  success:
    "✓ Your request has been sent successfully. We will contact you soon.",
  formError: "Please fill in all required fields.",
  errors: {
    nameRequired: "Please enter your full name.",
    emailRequired: "Please enter your email.",
    emailInvalid: "Invalid email format.",
    phoneRequired: "Please enter your phone number.",
    phoneInvalid: "Phone number must be 10 digits.",
    projectTypeRequired: "Please choose a project type.",
    companyRequired: "Please enter the project name.",
    requestTypeRequired: "Please choose the request type.",
    servicesRequired: "Please choose at least one service.",
    packageRequired: "Please choose one package.",
  },
}, /* end*/
};

export default en;

